<div class="card right-top">
    <header class="row">
        <div class="header-home col-md-1 col-lg-1 col-sm-1 row">
            <a href="/"><i class="fa fa-home"></i></a>
        </div>
        <div class="header-title col-md-3 col-lg-3 col-sm-3 row text-center">
            <img src="./assets/image/mainlogo.png" class="d-md-none d-lg-none" width="35px" height="32px">
            <p class="d-none d-md-block d-lg-block">
                
                SELL
                
            </p>
            <span class="col-md-1 col-lg-1 px-0 pipe-hr d-none d-md-block d-lg-block"></span>
        </div>
        <div class="header-path col-md-2 col-sm-2 col-lg-2 mx-auto d-none d-md-block d-lg-block">
            <p>DATA MARKETPLACE</p>
        </div>
        <div class="header-actions col-md-4 col-sm-4 col-lg-4 mx-auto d-none d-md-block d-lg-block">
          <div class="row">
            <div class="col-lg-2 mx-2 mt-1">
               <a class="coupon_action">
                   <div class="row pl-1"><img src="./assets/image/coupon_icon.png" alt="arrow" width="23"></div>
                <div class="row text-center mt-1">Coupon</div>
               </a>
                <app-coupon></app-coupon>
            </div>
            <div class="col-lg-2 ml-2"> 
              <a class="walletlink">
               <div class="row pl-1"><img src="./assets/image/wallet.svg" alt="arrow" width="20"></div>
                <div class="row text-center mt-1">Wallet</div>
              </a>
            </div>
            <div class="col-lg-2 mr-3 ml-1">
            <span class="notification_number bg-success text-white text-center">3</span> 
                <a class="notification_show">
                   <div class="row pl-3"><img src="./assets/image/notifications.svg" alt="arrow" width="16"></div>
                <div class="row mt-1">Notifications</div>
               </a>
                <app-notification></app-notification>
            </div>
             <div class="col-lg-2 ml-3">
                <a class="quick_action">
                   <div class="row pl-3"><img src="./assets/image/icons/quick_action.png" alt="arrow" width="19"></div>
                <div class="row text-center mt-1">Quick Action</div>
               </a>
                <app-quickaction></app-quickaction>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-lg-2 col-sm-2">
            <div class="header-profile col-sm-12 col-md-12 col-lg-12 row col-12">
                <div class="profile-pic col-md-12 col-lg-12 col-sm-12 col-12">
                    <img src="./assets/image/profile_pic1.jpeg" width="40px" alt="profile-image" class="d-none d-md-block d-lg-block">
                    <img src="./assets/image/profile_pic1.jpeg" width="30px" alt="profile-image" class="d-md-none d-lg-none">
                    <span class="status"></span>
                    <p>Gaurav Gupta</p>
                </div>                                    
            </div>
             <app-profilemodal></app-profilemodal>
        </div>
    </header>
    <div class="row mob-nav d-md-none d-lg-none">
        <div class="col-1">
            <div class="mob-hr">
                <p class="nav-hr"></p>
                <p class="nav-hr"></p>
                <p class="nav-hr"></p>
            </div>
        </div>
        <div class="col-10">
            <div class="mob-page">
                <p>MARKET PLACE</p>
            </div>
        </div>
    </div>
</div>
